/** AUTO: provide React globals (replaces old CDN scripts) **/
import * as React from "react";
import * as ReactDOM from "react-dom/client";

window.React = React;
// ReactDOM shim already exports createRoot (React 18) + render (legacy)
window.ReactDOM = ReactDOM;
/** END AUTO **/
// Bundle Entry Point (esbuild-bundled React)
import { App } from '../../src/App.jsx';
import { ErrorBoundary } from '../../src/components/ErrorBoundary.jsx';
import { LoginScreen } from '../../src/components/LoginScreen.jsx';
import { useAuth } from '../../src/hooks/useAuth.js';
import { useThemeStore } from '../../src/admin/designer/store/themeStore.js';

import { useScrollRestoration } from '../../src/hooks/useScrollRestoration.js';

// --- Auth Wrapper ---
function AppRoot() {
  const { user, isAuthenticated, login, error } = useAuth();
  const fetchThemes = useThemeStore(state => state.fetchThemes);
  
  // Call scroll restoration hook
  useScrollRestoration();
  
  React.useEffect(() => {
    fetchThemes();
  }, [fetchThemes]);
  
  if (!isAuthenticated) {
    return <LoginScreen onLogin={login} error={error} />;
  }

  return <App />;
}

// Render App
const rootElement = document.getElementById('root');
if (rootElement && ReactDOM.createRoot) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <ErrorBoundary>
      <AppRoot />
    </ErrorBoundary>
  );
} else if (rootElement) {
  // Legacy render (React 17 or older polyfill fallback)
  window.ReactDOM.render(
    <ErrorBoundary>
      <AppRoot />
    </ErrorBoundary>, 
    rootElement
  );
}
